import React from "react";
import shareEatsImg from "../../../assets/projects/shareEates.png";
import { FiGithub } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";

const Project3 = () => {
  const shareEats = {
    projectName: "3. Share Eats",
    image: shareEatsImg,
    description:
      "Share Eats is a heartwarming endeavor developed to address food surplus and ensure it reaches those who need it most. Inspired by the generous spirit of Bangladesh's food-sharing culture, this application facilitates the sharing of surplus food from events like weddings and other gatherings. With Share Eats, the aim is to foster a community-driven approach to combating food waste while spreading joy and nourishment to those in need.",
    technologies: [
      "React",
      "Javascript",
      "Tailwind CSS",
      "MongoDB",
      "Express.js",
      "Firebase",
    ],
    gitHub: "https://github.com/Bikash-Dev-Bk/share-eats-client",
    live: "https://share-eats-6f19f.web.app/",
  };

  return (
    <div className="bg-[#f9f9f9]">
      <div className="lg:max-w-[1200px] mx-auto flex flex-col-reverse lg:flex-row gap-5 justify-between py-20 px-6 md:px-12 lg:px-2">
        <div className="flex-1 ">
          <h1 className="text-2xl font-bold ">{shareEats.projectName}</h1>
          <p className="text-justify mt-5">{shareEats.description}</p>

          <div>
            <h2 className="text-xl font-semibold my-4">Technology</h2>
            <ul>
              {shareEats.technologies.map((tech, index) => (
                <li key={index} className="flex gap-1 items-center">
                  🔷<span> {tech}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-10 flex gap-5">
            <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
              <a
                href={shareEats.gitHub}
                target="_blank"
                rel="noreferrer"
                className="flex gap-2 items-center"
              >
                <FiGithub className="text-2xl " />{" "}
                <span className="font-semibold">Code</span>
              </a>
            </p>
            <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
              <a
                href={shareEats.live}
                target="_blank"
                rel="noreferrer"
                className="flex gap-2 items-center"
              >
                <FiExternalLink className="text-2xl " />
                <span className="font-semibold">Live</span>
              </a>
            </p>
          </div>
        </div>
        <div className="flex-1">
          <img src={shareEats.image} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Project3;
